import {
  OnboardingEventsEnum,
  trackEvent,
  TrackingTypesEnum,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {delayAsync} from '../../../helpers/asyncHelpers';
import {buildTeamWorkspaceExpandedKey} from '../../../helpers/models/localPreferencesHelpers';
import {completeCompanyOnboardingAction} from '../../../store/data/company/companyActions';
import {setExpandItemAction} from '../../../store/data/localPreferences/localPreferencesActions';
import {saveWasOnboardingCompletedAction} from '../../../store/data/preferences/preferencesActions';
import {onboardingGuidePopoverAnimationMs} from '../guide/onboardingGuidePopover';
import {OnboardingGuidesEnum} from '../guide/onboardingGuideTypes';
import {OnboardingFlowStep, OnboardingFlowStepNameEnum} from './onboardingFlowTypes';

export const onboardingFlowSteps: Record<OnboardingFlowStepNameEnum, OnboardingFlowStep> = {
  [OnboardingFlowStepNameEnum.DESKTOP_RECOMMENDATION]: {
    onStart: async (props) => {
      const {
        onboardingModalContext: {setOnboardingGuide},
      } = props;

      setOnboardingGuide(OnboardingGuidesEnum.DESKTOP_RECOMMENDATION);
    },
    onEnd: async () => {},
  },
  [OnboardingFlowStepNameEnum.ONBOARDING_QUESTIONNAIRE]: {
    onStart: async (props) => {
      const {
        onboardingModalContext: {setOnboardingGuide},
      } = props;

      setOnboardingGuide(OnboardingGuidesEnum.QUESTIONNAIRE);
      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.STARTED);
    },
    onEnd: async (props) => {
      const {dispatch} = props;

      await dispatch(saveWasOnboardingCompletedAction());
      await dispatch(completeCompanyOnboardingAction());

      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.ONBOARDING_QUESTIONNAIRE_COMPLETED);
      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED);
    },
  },
  [OnboardingFlowStepNameEnum.ONBOARDING_QUESTIONNAIRE_ADMIN_WIZARD]: {
    onStart: async (props) => {
      const {
        onboardingModalContext: {setOnboardingGuide},
      } = props;

      setOnboardingGuide(OnboardingGuidesEnum.ADMIN_WIZARD);
    },
  },
  [OnboardingFlowStepNameEnum.ADMIN_WIZARD]: {
    onStart: async (props) => {
      const {
        onboardingModalContext: {setOnboardingGuide},
      } = props;

      setOnboardingGuide(OnboardingGuidesEnum.ADMIN_WIZARD);

      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.STARTED);
    },
    onEnd: async (props) => {
      const {dispatch} = props;

      await dispatch(saveWasOnboardingCompletedAction());
      await dispatch(completeCompanyOnboardingAction());

      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED);
    },
  },
  [OnboardingFlowStepNameEnum.SANDBOX_DEMO]: {
    onStart: async (props) => {
      const {
        onboardingModalContext: {setOnboardingGuide},
        sandboxTeam,
        dispatch,
      } = props;

      setOnboardingGuide(undefined);
      // Don't show the education tip until the modal fades out.
      await delayAsync(onboardingGuidePopoverAnimationMs);

      if (!sandboxTeam) {
        return;
      }

      dispatch(setExpandItemAction(buildTeamWorkspaceExpandedKey(sandboxTeam.namespace), true));

      setOnboardingGuide(OnboardingGuidesEnum.SANDBOX_DEMO_INTRO);
    },
  },
  [OnboardingFlowStepNameEnum.SETUP_GUIDE]: {
    onStart: async (props) => {
      const {
        onboardingModalContext: {openAdminSetupGuideSetupScreen},
        onEndOnboardingFlow,
      } = props;

      openAdminSetupGuideSetupScreen();
      onEndOnboardingFlow();
    },
  },
  [OnboardingFlowStepNameEnum.FLU_GUIDE]: {
    onStart: async (props) => {
      const {
        onboardingModalContext: {setOnboardingGuide},
      } = props;

      setOnboardingGuide(OnboardingGuidesEnum.FRONT_LINE_USER_WELCOME);

      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.STARTED);
    },
    onEnd: async (props) => {
      const {dispatch} = props;

      await dispatch(saveWasOnboardingCompletedAction());

      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED_PERSONNA);
      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED);
    },
  },
};
